import firebase from "@firebase/app"
require("firebase/firestore")
require('firebase/auth')
require('firebase/storage')
require("firebase/functions");
require("firebase/analytics")

const config = {
  apiKey: "AIzaSyDjzNMycbbB-uo9zdrqofr4mltpiHrCaGc",
    authDomain: "international-d682f.firebaseapp.com",
    databaseURL: "https://international-d682f.firebaseio.com",
    projectId: "international-d682f",
    storageBucket: "international-d682f.appspot.com",
    messagingSenderId: "264520616989",
    appId: "1:264520616989:web:74add2787fccd2d4f64af4",
    measurementId: "G-MHGTD5B1P4"
  };
 

firebase.initializeApp(config)


const db = firebase.firestore()
const _firestore = firebase.firestore
const auth = firebase.auth()
const functions = firebase.functions()
const _auth = firebase.auth
const storage = firebase.storage()
const ColeccionLanding = db.collection('Landing').doc('Contenido')
const coleccion_blog = db.collection('Landing').doc('Contenido').collection('Blog')
const ColeccionLandingImagenes = db.collection('Landing').doc('Imágenes')
const coleccion_etiquetas = db.collection('Landing').doc('Etiquetas')
const FieldValue = _firestore.FieldValue
const enviar_correo_electronico = functions.httpsCallable('correo_electronico-enviar')

export {
  db,
  functions,
  auth,
  _auth,
  storage,
  firebase,
  ColeccionLanding,
  _firestore,
  ColeccionLandingImagenes,
  coleccion_blog,
  coleccion_etiquetas,
  FieldValue,
  enviar_correo_electronico
}